export function concatPath(pathArray: (string | undefined)[]) {
  const path = pathArray.filter(Boolean).join('/');

  return path ? `/${path}/`.replace(/\/+/g, '/') : '/';
}
